module.exports = __webpack_public_path__ + "static/media/sopt14ru.00ba04f8.pdf";